import { api } from "./api";
import {
  clearReferralAttributionToken,
  loadOnboardingSession,
} from "./onboarding";

/**
 * Best-effort post-auth handoff for opaque referral tokens. The API returns no
 * lifecycle information: a successful 204 means only that the service safely
 * processed the request, whether it attributed or intentionally no-op'd.
 */
export async function attributeReferralToken(
  getToken: () => Promise<string | null>,
  token: string,
): Promise<void> {
  const authToken = await getToken();
  await api.post<void>(
    "/api/referrals/attribute",
    { token },
    authToken ?? undefined,
  );
}

/**
 * Consumes the currently captured handoff only after an authenticated request
 * completed. It is safe to call after every successful onboarding submit and
 * again from a protected route: a successful service no-op still clears the
 * token, while a transient failure leaves it available for the next attempt.
 */
export async function attributePendingReferralToken(
  getToken: () => Promise<string | null>,
): Promise<void> {
  const token = loadOnboardingSession()?.referralAttributionToken;
  if (!token) return;
  await attributeReferralToken(getToken, token);
  clearReferralAttributionToken(token);
}
